export const ACTION_TYPES = {
    create: 'create',
    edit: 'edit',
    delete: 'delete',
};

export const SORT_DIRECTION = {
    asc: 'asc',
    desc: 'desc',
};